import { useSkuSelector } from '../hooks/useSkuSelector';

type SelectorInternalBoxProps = {
	children: React.ReactNode;
	selected: boolean;
};

const SelectorInternalBox = ({ children, selected }: SelectorInternalBoxProps) => {
	const { blockClass, handles, prodSum } = useSkuSelector();

	const renderClass = () => blockClass && `vtex-store-components-3-x-skuSelectorInternalBox--${blockClass}`;

	return (
		<div
			className={`${prodSum ? handles.skuSelectorInternalBox : ''} skuSelectorInternalBox skuSelectorInternalBox--${blockClass} vtex-store-components-3-x-skuSelectorInternalBox ${renderClass()} w-100 h-100 b--muted-4 br2 b z-1 c-muted-5 flex items-center overflow-hidden ${
				selected ? '' : 'hover-b--muted-2'
			} ba`}
		>
			<div className="absolute absolute--fill"></div>
			{children}
		</div>
	);
};

export default SelectorInternalBox;
